import { createContext, useContext } from 'react';
export const queryClientProviderConfigContext = createContext({
    allowPersist: false,
});
queryClientProviderConfigContext.displayName = 'QueryClientProviderConfigContext';
export function useQueryClientProviderConfig() {
    return useContext(queryClientProviderConfigContext);
}
//# sourceMappingURL=QueryClientProviderContext.js.map